const moduleApi = require.context('./modules', false, /\.js$/)

let api = {}

moduleApi.keys().forEach(key => {
  const mod = moduleApi(key).default
  api = { ...api, ...mod }
})

// console.log('api', api)

export default api
